import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IProductRepository } from './Iproduct.repository';
import { ApiResponse, Fitbone, FitboneSearchFilters } from './models';


@Injectable({ providedIn: 'root' })
export class ProductRepository implements IProductRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly config = inject(APP_CONFIG);


	getFitboneList(filters: FitboneSearchFilters): Observable<ApiResponse<Fitbone[]>> {
		return this.httpClient.post<ApiResponse<Fitbone[]>>(this.config.domainTemplatesAPI + '/api/Fitbone/GetFitboneList', filters);
	}

}
